import { render, staticRenderFns } from "./IosPwaModal.vue?vue&type=template&id=4ad9a9b7&"
import script from "./IosPwaModal.vue?vue&type=script&lang=ts&"
export * from "./IosPwaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports